export function assertString(subject: any): asserts subject is string {
  if (typeof subject !== 'string') {
    throw new Error(`Missing environment variable`);
  }
}
